import React from 'react'
import setClass from 'classnames'

const Button = (props) => {
  const { type, onClick, text, isLoading, styleClass } = props.fieldData
  const classNames = setClass({'is-loading': isLoading}, styleClass)
  return (
    <button className={`button ${classNames}`} type={type} onClick={onClick}>
      {text}
    </button>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/generic/Button.js